import React, { useContext, useState } from "react";
import styles from "../Profile/Profile.module.css";
import { useNavigate } from "react-router";
import arrow from "../../assests/arrow4.png";
import support from "../../assests/support.png";
import warning from "../../assests/warning.png";
import privacy from "../../assests/privacy.png";
import signout from "../../assests/signout.png";
import Signout from "./Signout";
import Context from "../../context/Context";
import { createSearchParams } from "react-router-dom";
import { useUserAuth } from "../../context/UserAuthContext";

const ProfileSettings = ({ setSettings }) => {
  const [signOut, setSignOut] = useState(false);
  const navigate = useNavigate();
  const { preview, isMobile } = useContext(Context);
  const { searchParams } = useUserAuth();
  return (
    <>
      <div className="h-[100%] cursor-pointer">
        <div className="flex flex-col ">
          <div className="flex flex-col gap-[12px] w-[100%]  font-medium  text-[#0F6ABE] text-regular">
            <div
              onClick={() => {
                if (preview) {
                  navigate({
                    pathname: "help",
                    search: "?preview=true",
                  });
                } else {
                  navigate({
                    pathname: "help",
                    search: `${
                      searchParams ? createSearchParams(searchParams) : ""
                    }`,
                  });
                }
              }}
            >
              <p>Help & Support </p>
            </div>
            {isMobile && (
              <div
                onClick={() => {
                  navigate({
                    pathname: "rules",
                    search: `${
                      searchParams ? createSearchParams(searchParams) : ""
                    }`,
                  });
                }}
              >
                <p>Contest Rules</p>
              </div>
            )}
            <div
              onClick={() => {
                if (preview) {
                  navigate({
                    pathname: "tandc",
                    search: "?preview=true",
                  });
                } else {
                  navigate({
                    pathname: "tandc",
                    search: `${
                      searchParams ? createSearchParams(searchParams) : ""
                    }`,
                  });
                }
              }}
            >
              <p>Terms & Conditions</p>
            </div>

            <div
              onClick={() => {
                if (preview) {
                  navigate({
                    pathname: "privacy",
                    search: "?preview=true",
                  });
                } else {
                  navigate({
                    pathname: "privacy",
                    search: `${
                      searchParams ? createSearchParams(searchParams) : ""
                    }`,
                  });
                }
              }}
            >
              <p>Privacy Policy </p>
            </div>
          </div>
          <div className="seperator my-[20px]" />

          <button
            onClick={() => {
              setSignOut(true);
            }}
            className="text-regular text-[#CDCDCD] mr-auto pb-[30px]"
          >
            Sign Out
          </button>
          <button
            onClick={() => {
              navigate("/profile/delete");
            }}
            className="text-regular text-[#cb3838] mr-auto "
          >
            Delete Account
          </button>
        </div>
      </div>
      {/* {settings !== "" && <Settings settings={settings} setSettings={setSettings}/> } */}
      {signOut && <Signout setSignOut={setSignOut} />}
    </>
  );
};

export default ProfileSettings;
